var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"marketplace-nav-btn",class:{ 'marketplace-nav-btn--active': _vm.isMarketplaceRoute },attrs:{"type":"button"},on:{"click":_vm.goToMarketplace}},[_c('v-icon',{staticClass:"market-icon",attrs:{"size":"18","color":"currentColor"}},[_vm._v("$marketplace")]),_c('span',{staticClass:"market-label"},[_vm._v("Маркетплейс")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }